<template>
  <v-container fluid tag="section" class="pa-0">
     <base-material-card-list :item='item' ref="table">
      <template v-slot:title="{ loading }">
          <v-card-text>
            <v-row>
              <v-col cols="12" md='2' class="pr-0">
                <v-text-field
                 outlined dense
                  hide-details
                  clearable
                  v-model='item.params.customerName'
                  item-value="value"
                  clear-icon="mdi-close-circle-outline"
                  @keydown="queryKeyDown()"
                  label="客户名称" >
                </v-text-field>
              </v-col>
              <v-col cols="12" md='2' class="pr-0">
                <v-text-field
                 outlined dense
                  hide-details
                  clearable
                  v-model='item.params.patentCode'
                  item-value="value"
                  clear-icon="mdi-close-circle-outline"
                  @keydown="queryKeyDown()"
                  label="专利编号" >
                </v-text-field>
              </v-col>
              <v-col cols="12" md='2'>
                <v-btn color="primary" :loading="loading" @click="loadData" class="mr-1 px-2" dark depressed>
                  <v-icon>mdi-magnify</v-icon>
                  查询
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
        <template v-slot:content="{ records }">
          <v-row>
            <v-col cols="12" md="6" v-for="(item, idx) in records" :key="idx">
              <v-hover v-slot="{ hover }">
                <v-card class="rounded-lg" :elevation="hover ? 2 : 0">
                  <v-card-title class="size-14">
                    <v-chip small :color="item.patentType === 1 ? 'success' : item.patentType === 2 ? 'cyan' : 'blue'" class="mr-1" dark label>
                      {{item.patentType === 1 ? '实用新型' : item.patentType === 2 ?'发明专利' : '外观专利'}}
                    </v-chip>
                    【{{item.patentCode || '--'}}】{{item.name}}
                    <v-spacer></v-spacer>
                    <span class="primary--text">{{item.statusVal}}</span>
                  </v-card-title>

                  <v-divider class="mx-4"></v-divider>

                  <v-card-title class="size-15">
                    附件信息
                    <v-spacer></v-spacer>
                    <strong>{{item.updateTime | formatDate}}</strong>
                  </v-card-title>

                  <v-card-text>
                    <p>受理通知书：
                      <span v-if="item.acceptFileName" class="font-weight-black">
                        <v-btn class="pl-0" text color="primary" small @click="view(item.acceptFilePath)">{{item.acceptFileName.substring(item.acceptFileName.lastIndexOf('/')+1,item.acceptFileName.length)}}</v-btn>
                      </span>
                    </p>
                    <p>受理费收据：
                      <span v-if="item.acceptCostFilePath !== null && item.acceptCostFilePath.length > 0" class="font-weight-black">
                        <v-btn class="pl-0" text color="primary" v-for="(file, index) in item.acceptCostFilePath" :key="index" small @click="view(file)">收据{{index+1}}</v-btn>
                      </span>
                    </p>
                    <p>授权通知书：
                      <span v-if="item.authFileName" class="font-weight-black">
                        <v-btn class="pl-0" text color="primary" small @click="view(item.authFilePath)">{{item.authFileName.substring(item.authFileName.lastIndexOf('/')+1,item.authFileName.length)}}</v-btn>
                      </span>
                    </p>
                    <p>授权费收据：
                      <span v-if="item.authCostFilePath !== null && item.authCostFilePath.length > 0" class="font-weight-black">
                        <v-btn class="pl-0" text color="primary" v-for="(file, index) in item.authCostFilePath" :key="index" small @click="view(file)">收据{{index+1}}</v-btn>
                      </span>
                    </p>
                    <p>电子版证书：
                      <span v-if="item.certFileName" class="font-weight-black">
                        <v-btn class="pl-0" text color="primary" small @click="view(item.certFilePath)">{{item.certFileName}}</v-btn>
                      </span>
                    </p>
                    <p>年&nbsp;费&nbsp;收&nbsp;据：
                      <span v-if="item.patentCostList" class="font-weight-black" v-for="(file, index) in item.patentCostList" :key="index">
                        <span v-if="file.costFileName" class="font-weight-black" v-for="(p, idx) in file.costFilePath" :key="idx">
                          <v-btn class="pl-0" text color="primary" small @click="view(p)">收据{{idx+1}}({{file.year}})</v-btn>
                        </span>
                      </span>
                    </p>
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </v-card-text>
      </template>
    </base-material-card-list>
  </v-container>
</template>

<script>

  export default {
    components: {
    },
    name: 'FileDetail',
    data() {
      return {
        item: {
          path: '/patent/info/list',
          params: {
            status: [25, 30, 31, 35, 36],
            listType: 2,
            customerName: '',
            patentCode: ''
          },
          sort: {
            orderByField: 'update_time'
          }
        }
      }
    },
    methods: {
      queryKeyDown () {
        if (window.event.keyCode === 13) {
          this.loadData()
        }
      },
      view (path) {
        if (path) {
          window.open(
            path,
            "_blank"
          );
        }
      },
      loadData () {
        this.$refs.table.loadData()
      }
    }
  }
</script>
